document.addEventListener('click', (event) => {
  const swatch = event.target.closest('.vybe-card__swatch');
  if (!swatch) return;

  const card = swatch.closest('[data-vybe-card]');
  if (!card) return;

  for (const other of card.querySelectorAll('.vybe-card__swatch')) {
    other.classList.toggle('is-selected', other === swatch);
  }

  const { variantId, price, compare, off, mediaId, available } = swatch.dataset;

  const input = card.querySelector('[data-vybe-variant-input]');
  if (input && variantId) input.value = variantId;

  const priceEl = card.querySelector('[data-vybe-price]');
  if (priceEl && price) priceEl.textContent = price;

  const compareEl = card.querySelector('[data-vybe-compare]');
  if (compareEl) {
    compareEl.textContent = compare || '';
    compareEl.hidden = !compare;
  }

  const offEl = card.querySelector('[data-vybe-off]');
  if (offEl) {
    offEl.textContent = off || '';
    offEl.hidden = !off;
  }

  const button = card.querySelector('[data-vybe-atc]');
  if (button) {
    const inStock = available === 'true';
    button.disabled = !inStock;
    button.textContent = inStock ? button.dataset.labelAvailable : button.dataset.labelSoldOut;
  }

  const track = card.querySelector('.vybe-card__swipe');
  const slide = mediaId && card.querySelector(`.vybe-card__slide[data-media-id="${CSS.escape(mediaId)}"]`);
  if (track && slide) {
    track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
  }
});

/*
 * VYBE mobile: while scrolling DOWN, product cards on screen slide to their 2nd image;
 * while scrolling UP, they slide back to the 1st image. Desktop is unchanged.
 * If a shopper swipes a card or taps a colour swatch, that card is left alone.
 */
(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const visibleCards = new Set();
  const observed = new WeakSet();
  let direction = 'down';
  let lastY = window.scrollY;
  let ticking = false;

  const trackOf = (card) => card.querySelector('.vybe-card__swipe');

  function showImage(card, index, smooth = true) {
    if (card.dataset.vybeManual === '1') return;
    const track = trackOf(card);
    if (!track || track.querySelectorAll('.vybe-card__slide').length < 2) return;
    const left = track.clientWidth * index;
    if (Math.abs(track.scrollLeft - left) < 2) return;
    track.scrollTo({ left, behavior: smooth && !reduceMotion.matches ? 'smooth' : 'auto' });
  }

  const observer = new IntersectionObserver(
    (entries) => {
      if (!mobile.matches) return;
      for (const entry of entries) {
        const card = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
          visibleCards.add(card);
          showImage(card, direction === 'down' ? 1 : 0);
        } else if (!entry.isIntersecting) {
          visibleCards.delete(card);
          delete card.dataset.vybeManual;
          showImage(card, 0, false);
        } else {
          visibleCards.delete(card);
        }
      }
    },
    { threshold: [0, 0.6] }
  );

  function observeCards(root = document) {
    root.querySelectorAll('[data-vybe-card]').forEach((card) => {
      if (observed.has(card)) return;
      observed.add(card);
      observer.observe(card);
    });
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      if (!mobile.matches) return;
      const y = window.scrollY;
      const delta = y - lastY;
      if (Math.abs(delta) < 6) return;
      lastY = y;
      const next = delta > 0 ? 'down' : 'up';
      if (next === direction) return;
      direction = next;
      visibleCards.forEach((card) => showImage(card, direction === 'down' ? 1 : 0));
    });
  }

  // A shopper swiping a card or picking a colour takes over that card.
  const markManual = (event) => {
    const card = event.target.closest('[data-vybe-card]');
    if (card && event.target.closest('.vybe-card__swipe, .vybe-card__swatch')) {
      card.dataset.vybeManual = '1';
    }
  };
  document.addEventListener('touchstart', markManual, { passive: true, capture: true });
  document.addEventListener('click', markManual, true);

  window.addEventListener('scroll', onScroll, { passive: true });

  const start = () => {
    observeCards();
    new MutationObserver((mutations) => {
      for (const m of mutations) {
        m.addedNodes.forEach((node) => {
          if (node.nodeType === 1) observeCards(node.matches && node.matches('[data-vybe-card]') ? node.parentElement || document : node);
        });
      }
    }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();